import { Controller } from "@hotwired/stimulus"

// Navigates on change. If a `template` value is set (containing "__ID__"), the
// selected value is substituted into it; otherwise the value is used as the URL.
export default class extends Controller {
  static values = { template: String }

  go(event) {
    const value = event.target.value
    if (!value) return

    const url = this.hasTemplateValue ? this.templateValue.replace("__ID__", value) : value
    Turbo.visit(url)
  }
}
